const formatTime = (timestamp) => {
  const date = new Date(timestamp * 1000)
  const Y = date.getFullYear() + '-'
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const hours = date.getHours() + ':'
  const minutes = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  const seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return { date: Y + M + D, time: hours + minutes + seconds }
}

const matchFromUrl = (str) => {
  var reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g
  var url = str.match(reg)
  if (url) {
    str = str.replace(reg, '<a href=' + url[0] + ' target="_blank">' + url[0] + '</a>')
  }
  return str
}

export { formatTime, matchFromUrl }
